import { render, staticRenderFns } from "./MoveFile.vue?vue&type=template&id=a3aa9ba4&scoped=true"
import script from "./MoveFile.vue?vue&type=script&lang=js"
export * from "./MoveFile.vue?vue&type=script&lang=js"
import style0 from "./MoveFile.vue?vue&type=style&index=0&id=a3aa9ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3aa9ba4",
  null
  
)

export default component.exports